<!--
  ~ Created by Yaroslav S. on 16/04/24.
  ~ Copyright © 2024 SEVEN. All rights reserved.
-->

<div class="questions-content">
  <div class="questions-content-full">
    <div class="questions-content-section">
      <div class="questions-content-section-item">
        <div class="question-row m-b-24">
          <div class="question-row-title">{{ 'student.cumulativeTest.uploadAnswerAI' | translate }}</div>
          <curr-ai-upload-files
            [title]="'student.cumulativeTest.uploadScreenshots' | translate"
            [aiFilesType]="'question'"
            [automaticallyImport]="true"
            [enableProgressBar]="false"
            [isMultiple]="true"
            [isLoading]="isLoadingContent"
            [initImages]="imagesStore.questionImages ?? null"
            (onLoadedFile)="onLoadedFile($event)"
            (onCollectedFiles)="onSendToAI($event)"
          ></curr-ai-upload-files>
        </div>
      </div>
      <div class="questions-content-section-item">
        <div class="question-row-title">{{ 'student.cumulativeTest.recognizeWithAI' | translate }}</div>

        <div class="contenr-loader" *ngIf="isLoadingContent">
          <mat-spinner [strokeWidth]="5" [diameter]="38"></mat-spinner>
        </div>

        <div class="question-row-desc" *ngIf="isLoadingContent">
          {{ 'student.cumulativeTest.pleaseBePatient' | translate }}. {{ 'student.cumulativeTest.aiProcessing' | translate }}
        </div>

        <curr-tiny-editor-v2
          [title]="'student.cumulativeTest.answer' | translate"
          [subtitle]="'student.cumulativeTest.editor' | translate"
          [formGroup]="form"
          controlName="recognizedAnswer"
          [options]="{ height: 350, placeholder: ('student.cumulativeTest.answer' | translate) }"
          [value]="recognizedText"
          (valueChange)="onAnswerChange($event)"
        ></curr-tiny-editor-v2>
      </div>
    </div>
  </div>

  <div class="questions-content-actions">
    <div class="actions-item">
      <curr-button class="without-lines" variant="outlined" size="big" (click)="cancelQuestion()">{{ 'shared.studentNotes.cancel' | translate }}</curr-button>
    </div>

    <div class="actions-item">
      <curr-button
        variant="contained"
        size="big"
        [isDisabled]="!form.valid || isLoadingContent"
        (click)="saveNewQuestion()">
        {{ 'student.cumulativeTest.addAnswer' | translate }}
      </curr-button
      >
    </div>
  </div>
</div>
